/* eslint-disable */
// ### IMPORTS GENERAL FOR COMPONENT
// import basics
import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import "moment/locale/es";
import "moment/locale/pt";

// import Material UI
import {
  Typography,
  TextField,
  Tooltip,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  AppBar,
  Toolbar,
} from "@material-ui/core";
import { AddCircle, Event, Save, Edit, Close } from "@material-ui/icons";
import ChecklistRtlIcon from "@material-ui/icons/AssignmentTurnedIn";
import { Autocomplete } from "@material-ui/lab";
import HourglassEmpty from "@material-ui/icons/HourglassEmpty";

// import internal components
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";

// ### ONE PAGE | COMPONENT: APP BAR
const OnePageAppBar = ({
  isCreatingOnePage,
  isEditingOnePage,
  newDate,
  canReport,
  canApprove,
  handleSaveNewOnePage,
  handleOpenCancelDialog,
  handleEditOnePage,
  handleCreateOnePage,
  isCancelDialogOpen,
  handleCloseCancelDialog,
  handleConfirmCancel,
  selectedOnePageDate,
  setSelectedOnePageDate,
  onePageDateList,
  userDetails,
  onePageHasApproval,
  handleOpenApproveDrawer,
  t,
  classes,
}) => {
  return (
    <AppBar
      position="static"
      color="default"
      elevation={0}
      style={{ borderRadius: "4px", border: "1px" }}
    >
      <Toolbar style={{ display: "flex", flexGrow: 1, minHeight: "48px" }}>
        <GridContainer
          alignItems="center"
          style={{ margin: 0, padding: 0 }}
          spacing={2}
        >
          <GridItem xs={12}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%",
              }}
            >
              {/* APP BAR CASE CREATING ONE PAGE */}
              {isCreatingOnePage ? (
                <>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      marginLeft: "-12px",
                    }}
                  >
                    <Typography
                      style={{
                        fontWeight: 400,
                        marginTop: "3px",
                        fontSize: "18px",
                      }}
                    >
                      {isEditingOnePage
                        ? t("initiative_selected.one_page_editing", {
                            date: moment(newDate).format("LL"),
                          })
                        : t("initiative_selected.one_page_add_new_title")}
                    </Typography>
                  </div>
                  <div
                    style={{
                      color: "#3C4858",
                      display: "flex",
                      justifyContent: "flex-end",
                      alignItems: "center",
                      gap: "15px",
                      marginRight: "-12px",
                    }}
                  >
                    <Tooltip title={t("initiative_selected.cancel")}>
                      <Close
                        onClick={handleOpenCancelDialog}
                        className={classes.iconButtonCustom}
                        style={{ cursor: "pointer", fontSize: "20px" }}
                      />
                    </Tooltip>
                    <Tooltip title={t("initiative_selected.save")}>
                      <Save
                        onClick={handleSaveNewOnePage}
                        className={classes.iconButtonCustom}
                        style={{ cursor: "pointer", fontSize: "20px" }}
                      />
                    </Tooltip>
                    <Dialog
                      open={isCancelDialogOpen}
                      onClose={handleCloseCancelDialog}
                      aria-labelledby="cancel-dialog-title"
                      PaperProps={{
                        style: {
                          borderRadius: 8,
                          padding: "24px",
                          boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.15)",
                        },
                      }}
                    >
                      <DialogTitle
                        id="cancel-dialog-title"
                        style={{
                          fontSize: 20,
                          fontWeight: "bold",
                          textAlign: "center",
                          marginBottom: "20px",
                          marginTop: "-20px",
                        }}
                      >
                        {t("initiative_selected.cancel_confirmation_title")}
                      </DialogTitle>
                      <DialogContent
                        style={{
                          textAlign: "center",
                          marginBottom: "40px",
                          padding: 0,
                        }}
                      >
                        <Typography variant="body1" style={{ lineHeight: 1.6 }}>
                          {t("initiative_selected.cancel_confirmation_text")}
                        </Typography>
                      </DialogContent>
                      <DialogActions
                        style={{ justifyContent: "right", padding: 0 }}
                      >
                        <Button
                          onClick={handleCloseCancelDialog}
                          style={{
                            border: "1px solid #ccc",
                            borderRadius: 8,
                            padding: "8px 15px",
                            fontWeight: "bold",
                            textTransform: "none",
                            marginRight: "12px",
                          }}
                        >
                          {t("initiative_selected.cancel_no")}
                        </Button>
                        <Button
                          onClick={handleConfirmCancel}
                          style={{
                            backgroundColor: "#d32f2f",
                            color: "#fff",
                            borderRadius: 8,
                            padding: "8px 15px",
                            fontWeight: "bold",
                            textTransform: "none",
                          }}
                        >
                          {t("initiative_selected.cancel_yes")}
                        </Button>
                      </DialogActions>
                    </Dialog>
                  </div>
                </>
              ) : (
                <>
                  {/* APP BAR CASE VISUALIZING ONE PAGE */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      marginLeft: "-12px",
                      width: "100%",
                      boxSizing: "border-box",
                      overflow: "hidden",
                    }}
                  >
                    <Autocomplete
                      // As opções agora são objetos: [{ date, approval_status }, ...]
                      options={onePageDateList || []}
                      // 2. getOptionLabel: Diz ao Autocomplete qual propriedade do objeto usar como texto.
                      getOptionLabel={(option) =>
                        option ? moment(option.date).format("LL") : ""
                      }
                      // 3. renderOption: Customiza como cada item da lista dropdown é renderizado.
                      renderOption={(option) => (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            width: "100%",
                          }}
                        >
                          <span>{moment(option.date).format("LL")}</span>
                          {option.approval_status === "pending" && (
                            <Tooltip title={t("onepage.approval_pending")}>
                              <HourglassEmpty
                                style={{ color: "#F4C430", fontSize: 16 }}
                              />
                            </Tooltip>
                          )}
                        </div>
                      )}
                      // 4. value: Encontra o objeto correto na lista que corresponde à data selecionada.
                      value={
                        onePageDateList.find(
                          (opt) => opt.date === selectedOnePageDate
                        ) || null
                      }
                      // 5. onChange: Extrai apenas a string da data do objeto selecionado.
                      onChange={(event, newValue) => {
                        setSelectedOnePageDate(newValue ? newValue.date : "");
                      }}
                      classes={{
                        root: classes.autocompleteRoot,
                        inputRoot: classes.inputRoot,
                        option: classes.option,
                        paper: classes.paper,
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder={t("new_initiatives.fields.select_label")}
                          size="small"
                          InputProps={{
                            ...params.InputProps,
                            startAdornment: (
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <Event
                                  style={{
                                    fontSize: "18px",
                                    color: "#555",
                                    marginRight: "8px",
                                  }}
                                />
                                {params.InputProps.startAdornment}
                              </div>
                            ),
                            classes: { input: classes.inputText },
                            style: { fontSize: "12px", paddingLeft: "0" },
                          }}
                          classes={{ root: classes.textFieldRoot }}
                          style={{ width: "220px" }}
                        />
                      )}
                      style={{ minWidth: "220px" }}
                    />
                  </div>
                  <div
                    style={{
                      color: "#3C4858",
                      display: "flex",
                      justifyContent: "flex-end",
                      alignItems: "center",
                      gap: "10px",
                      marginRight: "-12px",
                      width: "100%",
                      boxSizing: "border-box",
                      overflowX: "hidden",
                    }}
                  >
                    {onePageHasApproval && canApprove && (
                      <Tooltip
                        title={t("initiative_selected.one_page_approve")}
                      >
                        <ChecklistRtlIcon
                          onClick={handleOpenApproveDrawer}
                          className={classes.iconButtonCustom}
                          style={{ cursor: "pointer", fontSize: "20px" }}
                        />
                      </Tooltip>
                    )}
                    <Tooltip title={t("initiative_selected.one_page_edit")}>
                      <span>
                        {" "}
                        <Edit
                          onClick={handleEditOnePage}
                          className={classes.iconButtonCustom}
                          disabled={!canReport}
                          style={{
                            cursor: canReport ? "pointer" : "not-allowed",
                            fontSize: "20px",
                            color: canReport ? "#3C4858" : "#ccc",
                          }}
                        />
                      </span>
                    </Tooltip>
                    <Tooltip title={t("initiative_selected.one_page_add_new")}>
                      <span>
                        <AddCircle
                          onClick={handleCreateOnePage}
                          className={classes.iconButtonCustom}
                          disabled={!canReport} // A mesma permissão de 'Editar' geralmente se aplica a 'Criar'
                          style={{
                            cursor: canReport ? "pointer" : "not-allowed",
                            fontSize: "20px",
                            color: canReport ? "#3C4858" : "#ccc",
                          }}
                        />
                      </span>
                    </Tooltip>
                  </div>
                </>
              )}
            </div>
          </GridItem>
        </GridContainer>
      </Toolbar>
    </AppBar>
  );
};

// ### PROPS TYPE VALIDATION AND EXPORT DEFAULT
OnePageAppBar.propTypes = {
  isCreatingOnePage: PropTypes.bool.isRequired,
  isEditingOnePage: PropTypes.bool.isRequired,
  isCancelDialogOpen: PropTypes.bool.isRequired,
  newDate: PropTypes.string.isRequired,

  handleSaveNewOnePage: PropTypes.func.isRequired,
  handleOpenCancelDialog: PropTypes.func.isRequired,
  handleEditOnePage: PropTypes.func.isRequired,
  handleCreateOnePage: PropTypes.func.isRequired,
  handleCloseCancelDialog: PropTypes.func.isRequired,
  handleConfirmCancel: PropTypes.func.isRequired,
  handleOpenApproveDrawer: PropTypes.func.isRequired,

  userDetails: PropTypes.object.isRequired,
  selectedOnePageDate: PropTypes.string.isRequired,
  setSelectedOnePageDate: PropTypes.func.isRequired,

  onePageDateList: PropTypes.array,
  onePageHasApproval: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
};

export default OnePageAppBar;
